import React from 'react';
import { Award, Users } from 'lucide-react';

const About = () => {
  const teamMembers = [
    {
      id: 1,
      name: 'Roman Schenkl',
      position: 'Geschäftsführer',
      image: '/images/team-roman.jpg',
      description: [
        'Roman Schenkl ist das Herzstück unseres Teams und bringt als Geschäftsführer nicht nur seine umfassende Management-Expertise ein, sondern auch seine tiefe Leidenschaft für den Kraftsport. Als aktiver Profi-Strongman weiß er aus erster Hand, was es bedeutet, Grenzen zu überschreiten und kontinuierlich an sich zu arbeiten.',
        'Seine Qualifikationen sprechen für sich: Als zertifizierter G.F.S.A Wettkampfrichter (German Federation of Strength Athletes) bringt er höchste fachliche Kompetenz mit und kennt die Standards des professionellen Kraftsports im Detail. Mit seiner Trainer B Lizenz verbindet er theoretisches Wissen mit praktischer Erfahrung und gibt sein Know-how mit Begeisterung an Athleten und Mitglieder weiter.',
        'Roman steht für kompromisslose Qualität, authentische Betreuung und die Vision, jedem zu helfen, sein persönliches Maximum zu erreichen.'
      ],
      qualifications: [
        'G.F.S.A Wettkampfrichter (German Federation of Strength Athletes)',
        'Trainer B Lizenz',
        'Aktiver Profi-Strongman'
      ]
    },
    {
      id: 2,
      name: 'Alessio Longhitano',
      position: 'Trainer in Ausbildung & Service Experte',
      image: '/images/team-alessio.jpg',
      description: [
        'Alessio Longhitano ist unser aufstrebender Nachwuchstrainer, der sich mit Ehrgeiz und Hingabe stetig weiterentwickelt. Aktuell in der Trainerausbildung befindlich, sammelt er wertvolle Praxiserfahrung und erweitert kontinuierlich sein fachliches Repertoire.',
        'Was Alessio besonders auszeichnet, ist seine Doppelrolle: Als Service Experte hat er stets ein offenes Ohr für die Anliegen unserer Mitglieder und sorgt dafür, dass sich jeder bei uns willkommen und bestens betreut fühlt. Seine Kombination aus technischem Fachwissen und ausgeprägter Serviceorientierung macht ihn zu einem geschätzten Ansprechpartner im Team.',
        'Mit seiner sympathischen Art und seinem Engagement trägt Alessio maßgeblich zur positiven Atmosphäre in unserem Studio bei und begleitet Mitglieder motiviert auf ihrem Weg zu ihren Fitnesszielen.'
      ],
      qualifications: [
        'Trainer in Ausbildung',
        'Service Experte'
      ]
    },
    {
      id: 3,
      name: 'Travis Eigenbrodt',
      position: 'Auszubildender Sport- und Fitnesskaufmann',
      image: '/images/team-roman.jpg',
      description: [
        'Travis Eigenbrodt repräsentiert die nächste Generation in unserem Team. Als Auszubildender zum Sport- und Fitnesskaufmann lernt er alle Facetten der Branche von der Pike auf kennen – von der Mitgliederbetreuung über betriebswirtschaftliche Prozesse bis hin zu Trainingsplanung und Kundenservice.',
        'Seine Ausbildung vermittelt ihm ein ganzheitliches Verständnis für die Fitnessbranche, das weit über das reine Training hinausgeht. Travis bringt frische Perspektiven ins Team ein und ist mit Begeisterung dabei, sich zu einem Allrounder zu entwickeln, der sowohl die sportliche als auch die kaufmännische Seite des Business versteht.',
        'Mit seiner Lernbereitschaft und seinem Engagement ist Travis eine Bereicherung für unser Team und steht exemplarisch für unseren Anspruch, nicht nur Mitglieder, sondern auch unsere eigenen Teammitglieder kontinuierlich weiterzuentwickeln.'
      ],
      qualifications: [
        'Auszubildender Sport- und Fitnesskaufmann'
      ]
    }
  ];

  return (
    <div className="bg-black min-h-screen pt-20">
      {/* Hero */}
      <section className="relative h-[70vh] flex items-center justify-center text-white">
        <div className="absolute inset-0">
          <img 
            src="/images/personal.jpg"
            alt="Unser Team"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/60" />
        </div>
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold tracking-tight mb-6 uppercase">
            Über uns
          </h1>
          <p className="text-xl text-white/90 mb-8">
            Lernen Sie das Team kennen, das Sie auf Ihrem Weg zu Ihren Fitnesszielen begleitet.
          </p>
        </div>
      </section>

      {/* Vision Section */}
      <section className="bg-white py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="text-center max-w-3xl mx-auto">
            <Users className="w-16 h-16 mx-auto mb-6 text-black" />
            <h2 className="text-4xl lg:text-5xl font-bold mb-8 text-black">
              Unsere Vision
            </h2>
            <p className="text-lg text-black/80 leading-relaxed">
              Bei POSITIV Fitness Studio steht der Mensch im Mittelpunkt. Unser engagiertes Team 
              verbindet fachliche Kompetenz mit echter Leidenschaft für Fitness und Gesundheit. 
              Wir glauben daran, dass jeder sein persönliches Maximum erreichen kann – mit der 
              richtigen Unterstützung, Motivation und einem Team, das an Sie glaubt.
            </p>
          </div>
        </div>
      </section>

      {/* Team Members */}
      <section className="bg-black py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-white">
              Unser Team
            </h2>
            <p className="text-xl text-white/80 max-w-3xl mx-auto">
              Drei Persönlichkeiten mit unterschiedlichen Stärken und einem gemeinsamen Ziel: 
              Ihren Erfolg zu ermöglichen.
            </p>
          </div>

          <div className="space-y-24">
            {teamMembers.map((member, index) => (
              <div 
                key={member.id} 
                className={`grid lg:grid-cols-2 gap-12 items-stretch ${
                  index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                }`}
              >
                {/* Image */}
                <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                  <div className="relative h-full overflow-hidden">
                    <img 
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                  </div>
                </div>

                {/* Content */}
                <div className={`flex ${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                  <div className="bg-white p-8 lg:p-12 flex flex-col h-full">
                    <h3 className="text-3xl lg:text-4xl font-bold mb-3 text-black">
                      {member.name}
                    </h3>
                    <p className="text-lg text-black/60 mb-6 font-medium">
                      {member.position}
                    </p>
                    
                    <div className="space-y-4 mb-8">
                      {member.description.map((paragraph, idx) => (
                        <p key={idx} className="text-black/80 leading-relaxed">
                          {paragraph}
                        </p>
                      ))}
                    </div>

                    {member.qualifications && member.qualifications.length > 0 && (
                      <div className="border-t border-black/10 pt-6">
                        <div className="flex items-center gap-2 mb-4">
                          <Award className="w-5 h-5 text-black" />
                          <h4 className="font-bold text-black">Qualifikationen</h4>
                        </div>
                        <ul className="space-y-2">
                          {member.qualifications.map((qual, idx) => (
                            <li key={idx} className="text-black/70 text-sm">
                              • {qual}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="bg-white py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-black">
              Unsere Werte
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                title: 'Kompetenz',
                description: 'Durch kontinuierliche Weiterbildung und praktische Erfahrung garantieren wir höchste fachliche Standards.'
              },
              {
                title: 'Authentizität',
                description: 'Wir leben, was wir lehren. Unsere Leidenschaft für Fitness ist echt und ansteckend.'
              },
              {
                title: 'Entwicklung',
                description: 'Wir wachsen mit unseren Mitgliedern und fördern aktiv die nächste Generation von Fitnessprofis.'
              }
            ].map((value, index) => (
              <div key={index} className="bg-black p-8 text-white">
                <h3 className="text-2xl font-bold mb-4">{value.title}</h3>
                <p className="text-white/80 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
